import { render, staticRenderFns } from "./RelativeHandle.vue?vue&type=template&id=0a990005&scoped=true"
import script from "./RelativeHandle.vue?vue&type=script&lang=js"
export * from "./RelativeHandle.vue?vue&type=script&lang=js"
import style0 from "./RelativeHandle.vue?vue&type=style&index=0&id=0a990005&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a990005",
  null
  
)

export default component.exports